// GA4 analytics — production-only (hostname allowlist), SPA-aware.
// The Measurement ID is public routing config, not a secret.

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

const ALLOWED_HOSTNAMES = new Set([
  'createcollect.com',
  'www.createcollect.com',
  'freelance-invoicer.emergent.host',
]);

const enabled =
  Boolean(MEASUREMENT_ID) &&
  typeof window !== 'undefined' &&
  ALLOWED_HOSTNAMES.has(window.location.hostname);

let initialized = false;
let lastPagePath = null;

export function initGA4() {
  if (!enabled || initialized) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  // page_view is sent manually on every router location change
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView({ pathname, search = '' }) {
  if (!enabled || !initialized) return;
  const path = `${pathname}${search}`;
  if (path === lastPagePath) return; // guard against duplicate consecutive fires
  lastPagePath = path;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: `${window.location.origin}${pathname}${search}`,
  });
}

export function trackEvent(name, parameters = {}) {
  if (!enabled || !initialized) return;
  window.gtag('event', name, parameters);
}

// Domain helpers — keep event names/params consistent. No PII in parameters.
export const analytics = {
  signUp: (method) => trackEvent('sign_up', { method }),

  invoiceCreated: (value, currency = 'USD') =>
    trackEvent('invoice_created', { value: Number(value) || 0, currency }),

  invoiceSent: () => trackEvent('invoice_sent', {}),

  linksTileTap: (label) =>
    trackEvent('links_tile_tap', { tile_label: String(label || '').slice(0, 100) }),

  beginCheckout: (plan, trial = false) =>
    trackEvent('begin_checkout', { plan, trial }),
};
